import * as React from "react";

const SvgIcnNoCrm = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 72 72" {...props}>
        <defs>
            <circle id="IcnNoCRM_svg__a" cx={9} cy={9} r={9} />
        </defs>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <g transform="translate(10 22)">
                <g fill="currentColor" fillRule="nonzero">
                    <path d="M23.51 7h25.98c.282 0 .51-.224.51-.5s-.228-.5-.51-.5H23.51a.505.505 0 00-.51.5c0 .276.228.5.51.5zM23.5 12h18a.5.5 0 100-1h-18a.5.5 0 000 1z" />
                </g>
                <circle stroke="currentColor" cx={9} cy={9} r={8.5} />
                <mask id="IcnNoCRM_svg__b" fill="#fff">
                    <use xlinkHref="#IcnNoCRM_svg__a" />
                </mask>
                <g mask="url(#IcnNoCRM_svg__b)" fillRule="nonzero" stroke="currentColor">
                    <g transform="translate(3.75 4.75)">
                        <circle cx={5.25} cy={2.75} r={3} />
                        <rect x={0.75} y={7.75} width={9} height={7} rx={2} />
                    </g>
                </g>
            </g>
            <path
                d="M.5 4v64c0 1.929 1.57 3.5 3.5 3.5h64c1.929 0 3.5-1.57 3.5-3.5V4C71.5 2.07 69.93.5 68 .5H4C2.07.5.5 2.07.5 4zM.5 11.5h71"
                stroke="currentColor"
            />
            <path
                d="M7.5 6a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM13.5 6a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM19.5 6a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z"
                stroke="currentColor"
            />
            <circle stroke="currentColor" cx={12} cy={50} r={2} />
            <circle stroke="currentColor" cx={36} cy={58} r={2} />
            <circle stroke="currentColor" cx={60} cy={45} r={2} />
            <path d="M.5 58l9.5-7M38 57.5l20-12M14 51l20 6.5M61.5 45.5l10 4" stroke="currentColor" />
        </g>
    </svg>
);

export default SvgIcnNoCrm;
